import React, { useState, useEffect } from "react";
import Wrappers from "../shared/Wrappers";
import FilterButtons from "../shared/FilterButtons";
import { FilterButtonsWrapper } from "./styles/DispatchesDetailsStyle";
import SenderDetails from "./SenderDetails";
import ReceiverDetails from "./ReceiverDetails";
import Quotation from "./Quotation";
import OrderDetails from "./OrderDetails";
import HeaderBreadcrumb from "../shared/HeaderBreadcrumb";
import { useParams } from "react-router-dom";
import { GetDispatchByID } from "../../../services/admin/dispatche";
import Loader from "../../shared/loader";

const DispatchesDetailsMain = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [AllData, setAllData] = useState([]);

  const OrderIds = AllData?.data?.order_id || "Order ID";

  const [activeButton, setactiveButton] = useState(0);
  const ButtonsArray = [
    { title: "Sender Details" },
    { title: "Receiver Details" },
    { title: "Order Details" },
    { title: "Quotation" },
  ];

  const SenderHeader = ["Dispatches", OrderIds, "Details", "Sender Details"];
  const customerHeader = [
    "Dispatches",
    OrderIds,
    "Details",
    "Receiver Details",
  ];
  const OrderHeader = ["Dispatches", OrderIds, "Details", "Order Details"];
  const QuotationHeader = ["Dispatches", OrderIds, "Details", "Quotation"];

  useEffect(() => {
    getSingleCustomer();
  }, [id]);

  const getSingleCustomer = async () => {
    await GetDispatchByID(setLoading, setAllData, id);
  };

  return (
    <Wrappers>
      {loading && <Loader />}
      {activeButton === 0 && (
        <HeaderBreadcrumb ItemsName={SenderHeader} GoTo="/admin/dispatches" />
      )}
      {activeButton === 1 && (
        <HeaderBreadcrumb ItemsName={customerHeader} GoTo="/admin/dispatches" />
      )}
      {activeButton === 2 && (
        <HeaderBreadcrumb ItemsName={OrderHeader} GoTo="/admin/dispatches" />
      )}
      {activeButton === 3 && (
        <HeaderBreadcrumb
          ItemsName={QuotationHeader}
          GoTo="/admin/dispatches"
        />
      )}
      <FilterButtonsWrapper>
        <FilterButtons
          ButtonsArray={ButtonsArray}
          activeButton={activeButton}
          setactiveButton={setactiveButton}
        />
      </FilterButtonsWrapper>

      {AllData && AllData?.message === "Success" && (
        <>
          {activeButton === 0 && (
            <SenderDetails data={AllData?.data?.stops[0] || {}} />
          )}
          {activeButton === 1 && (
            <ReceiverDetails data={AllData?.data?.stops[1] || {}} />
          )}
          {activeButton === 2 && (
            <OrderDetails data={AllData?.data?.stops[0] || {}} />
          )}
          {activeButton === 3 && <Quotation data={AllData?.data || ""} />}
        </>
      )}
    </Wrappers>
  );
};

export default DispatchesDetailsMain;
